// Redux slice for profile: state, reducers, and async thunk lifecycle handling.
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  checkAUTH,
  isUserNotLoggedIn,
  isTokenExpiredOnly,
} from "../../helper/helperFN";
import { createAuthError } from "../../utils/authError";
import api from "../../api/axios";
const BOOKING_URL = process.env.REACT_APP_BOOKING_API_URL;


// Async thunk to fetch user profile data
export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, { rejectWithValue }) => {



    try {
      const response = await api.post(
        BOOKING_URL + "/GetClientProfiles"
      );

      return response.data?.[0] || {};
    } catch (error) {

      // Handle API error response format
      if (error.response?.data?.success === false) {
        return rejectWithValue(error.response.data.errors || error.message);
      }

      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

// Async thunk to save profile data
export const saveProfile = createAsyncThunk(
  "profile/saveProfile",
  async (formData, { rejectWithValue }) => {


    try {
      // Make API call to save profile
      const response = await api.post(
        BOOKING_URL + "/SaveMainProfile",
        formData
      );

      if (response.data.success == false) {
        return rejectWithValue(response.data.errors || "Operation failed");
      }

      // Return both API response and form data
      return {
        success: response.data.success,
        formData: formData,
        message: response.data.errors,
      };
    } catch (error) {

      // Handle API error response format
      if (error.response?.data?.success === false) {
        return rejectWithValue(error.response.data.errors || error.message);
      }

      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

// Async thunk to fetch profile image
export const fetchProfileImage = createAsyncThunk(
  "profile/fetchProfileImage",
  async (_, { rejectWithValue }) => {


    try {
      // Make API call to get profile image
      const response = await api.post(
        BOOKING_URL + "/GetProfileImage"
      );

      return response.data?.[0]?.img_path || null;
    } catch (error) {

      // Handle API error response format
      if (error.response?.data?.success === false) {
        return rejectWithValue(error.response.data.errors || error.message);
      }

      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

// Async thunk to upload profile image
export const uploadProfileImage = createAsyncThunk(
  "profile/uploadProfileImage",
  async (imageFile, { rejectWithValue }) => {


    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user?.accessToken;
      const requestBody = { img: imageFile };

      // Make API call to upload image with multipart/form-data
      const response = await api.post(
        BOOKING_URL + "/saveProfileImage",
        requestBody,
        { isFormData: true }
        //     "Content-Type": "multipart/form-data",
      );

      return {
        success: response.data.success,
        url: URL.createObjectURL(imageFile),
        message: response.data.errors,
      };
    } catch (error) {

      // Handle API error response format
      if (error.response?.data?.success === false) {
        return rejectWithValue(error.response.data.errors || error.message);
      }

      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

// Async thunk: GetClient_Notification_Settings performs the API request for this slice.
export const GetClient_Notification_Settings = createAsyncThunk(
  "profile/GetClient_Notification_Settings",
  async (formData, { rejectWithValue }) => {
    // Check authentication with proper scenario detection



    try {
      const response = await api.post(
        `${BOOKING_URL}/GetClient_Notification_Settings`,
        formData
      );

      if (response.data.success === false) {
        return rejectWithValue(
          response.data.errors || "Failed to get notification setting"
        );
      }

      return response.data;
    } catch (error) {

      // Handle API error response format
      if (error.response?.data?.success === false) {
        return rejectWithValue(error.response.data.errors || error.message);
      }

      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);

// Async thunk: SaveClientNotificationSetting performs the API request for this slice.
export const SaveClientNotificationSetting = createAsyncThunk(
  "profile/SaveClientNotificationSetting",
  async (formData, { rejectWithValue }) => {
    // Check authentication with proper scenario detection



    try {
      const response = await api.post(
        `${BOOKING_URL}/SaveClientNotificationSetting`,
        formData
      );

      if (response.data.success === false) {
        return rejectWithValue(response.data.errors || "Failed to get Data");
      }

      return response.data;
    } catch (error) {

      // Handle API error response format
      if (error.response?.data?.success === false) {
        return rejectWithValue(error.response.data.errors || error.message);
      }

      return rejectWithValue(error.response?.data?.errors || error.message);
    }
  }
);
// Slice definition: contains local reducers and async thunk state transitions.
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: {},
    profileImage: null,
    Notifications: [],
    loading: false,
    error: null,
    success: null,
    message: null, // For API response messages
  },
    // Synchronous reducers for direct state updates from UI actions.
  reducers: {
    // Action to reset success/error states
    resetProfileStatus: (state) => {
      state.error = null;
      state.success = null;
      state.message = null;
    },
  },
  // Async lifecycle reducers for pending/fulfilled/rejected thunk states.
  extraReducers: (builder) => {
    builder
      // Fetch Profile cases
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.message = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
      })

      // Save Profile cases
      .addCase(saveProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.message = null;
      })
      .addCase(saveProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
        state.profileData = {
          ...action.payload.formData,
          profile_id: action.payload.formData.profile_id || 0,
        };
      })
      .addCase(saveProfile.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
        state.message = action.payload;
      })

      // Fetch Profile Image cases
      .addCase(fetchProfileImage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.message = null;
      })
      .addCase(fetchProfileImage.fulfilled, (state, action) => {
        state.loading = false;
        state.profileImage = action.payload;
      })
      .addCase(fetchProfileImage.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
        state.message = action.payload;
      })

      // Upload Profile Image cases
      .addCase(uploadProfileImage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.message = null;
      })
      .addCase(uploadProfileImage.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
        if (action.payload.success) {
          state.profileImage = action.payload.url;
        }
      })
      .addCase(uploadProfileImage.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
        state.message = action.payload;
      })
      .addCase(GetClient_Notification_Settings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.message = null;
      })
      .addCase(GetClient_Notification_Settings.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
        state.Notifications = action.payload;
      })
      .addCase(GetClient_Notification_Settings.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
        state.message = action.payload;
      })
      .addCase(SaveClientNotificationSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.message = null;
      })
      .addCase(SaveClientNotificationSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
      })
      .addCase(SaveClientNotificationSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { resetProfileStatus } = profileSlice.actions;
export default profileSlice.reducer;
